export default function Intro (){
   
   
    return (
        <div className="container--big-row">
            <div className= "content-section">
                <div className="intro-container">
                    <h1 className="intro-text ">Hosting enthusiasts globally are finding joy in utilizing Meow Hosting's offerings.</h1>
                    <div className="intro-buttons">
                    <button className="intro-button intro-button--red no-cursor">Get Started</button>
                    <button className="intro-button no-cursor">Contact us</button>
                    </div>
                </div>

            </div>
        </div>
        
        )
}